import { render, staticRenderFns } from "./BindDialog.vue?vue&type=template&id=58645304&scoped=true&"
import script from "./BindDialog.vue?vue&type=script&lang=js&"
export * from "./BindDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58645304",
  null
  
)

export default component.exports